import { z } from 'zod';
import { AdminActionInput } from '../shared.js';
import { TierKey, UpgradeRequestView } from '../../subscription.js';
// ── standing (FR-ADM-10…16) ───────────────────────────────────────────────
export const UpgradeQueueItem = UpgradeRequestView.extend({
    accountId: z.string(),
    reason: z.string(),
    documentUrls: z.array(z.string()),
    context: z.object({
        supporters: z.number().int(),
        supporterThreshold: z.number().int(),
        thresholdMet: z.boolean(),
        posts: z.number().int(),
        donationsReceivedMinor: z.number().int(),
        priorSanctions: z.number().int(),
    }),
});
export const DecideUpgradeInput = AdminActionInput.extend({ approve: z.boolean() });
export const TierConfigInput = AdminActionInput.extend({
    supporterThreshold: z.number().int().min(0).optional(),
    benefits: z.array(z.string()).max(10).optional(),
    description: z.string().max(2_000).optional(),
});
export const GrantTierInput = AdminActionInput.extend({ tier: TierKey });
//# sourceMappingURL=schemas.js.map